import {FC, useCallback, useState, useEffect} from "react";
import type {Dayjs} from "dayjs";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import useDevCycleSdk from "@/hooks/useDevCycleSdk";
import {CourseEnrollmentDueDateDialog} from "./components/CourseEnrollmentDueDateDialog";
import {useCourseEnrollmentActions} from "./hooks/useCourseEnrollmentActions";

interface IProps {
	open: boolean;
	onClose: () => void;
	courseId: number;
	cohortId: number;
}

export const EnrollCohortConfirmationModal: FC<IProps> = ({open, onClose, courseId, cohortId}) => {
	const {t} = useSSTranslation();
	const {dueDateAssignments} = useDevCycleSdk();
	const {enrollCohort, isCohortPending} = useCourseEnrollmentActions(courseId);
	const [dueDate, setDueDate] = useState<Dayjs | null>(null);

	useEffect(() => {
		if (!open) {
			setDueDate(null);
		}
	}, [open]);

	const handleApply = useCallback(() => {
		if (!open) {
			return;
		}

		enrollCohort(
			{
				cohortId,
				dueDate,
				showDueDateSection: dueDateAssignments
			},
			{onSuccess: onClose}
		);
	}, [open, cohortId, dueDate, dueDateAssignments, enrollCohort, onClose]);

	return (
		<CourseEnrollmentDueDateDialog
			open={open}
			onClose={onClose}
			onApply={handleApply}
			isPending={isCohortPending}
			showDueDateSection={dueDateAssignments}
			dueDate={dueDate}
			onDueDateChange={setDueDate}
			titleId="enroll-cohort-dialog-title"
			descriptionId="enroll-cohort-dialog-description"
			title={t("bulk_enrollment_modal_title", "Enroll Users in Course", {count: 1})}
			description={t("bulk_enrollment_modal_body_copy", "Enroll selected learners in this course.", {count: 1})}
		/>
	);
};
